import clsx from 'clsx'
import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { fieldConfigPropType, fieldItemPropType } from '../propTypes'
import SydLinkButton from '../../../../commonDesign/LinkButton'
import useNormalizedConfig, { getNormalizedConfig } from '../../hooks/useNormalizedValues'

function RSSFeedItemFooterItem ({
  config: _config,
  item,
  index
}) {
  const config = useNormalizedConfig(item, _config)

  if (!config?.value?.length) return null
  return (
    <div
      key={index}
      className={clsx(config?.className ?? '')}
      style={config.style}
    >
      {config.accessor === 'link' ? (
        <div style={{ maxWidth: 'fit-content' }}>
          <SydLinkButton
            size='sm' {...config} href={config.value} target='_blank' rel='noopener noreferrer'
            key={index}
          >{config.label ?? 'Read more'}
          </SydLinkButton>
        </div>
      ) : config.value}
    </div>
  )
}

RSSFeedItemFooterItem.propTypes = {
  config: fieldConfigPropType.isRequired,
  item: fieldItemPropType.isRequired,
  index: PropTypes.number.isRequired
}

function RSSFeedItemFooter ({
  config,
  item,
  className,
  style,
  ...rest
}) {
  const mappedConfigs = useMemo(() => {
    if (!config?.length) return []
    return config
      .map((configItem) => getNormalizedConfig(item, configItem)
      )?.filter(({ value }) => !!value?.length)
  }, [config, item])

  if (!mappedConfigs?.length) return null

  return (
    <div {...rest} className={clsx('flex flex-wrap gap-5 items-center w-full mt-2', className ?? '')} style={style}>
      {mappedConfigs?.map((configItem, index) => (
        <>
          <RSSFeedItemFooterItem
            key={index + configItem.accessor}
            index={index}
            item={item}
            config={configItem}
          />
        </>
      ))}
    </div>
  )
}

RSSFeedItemFooter.propTypes = {
  config: fieldConfigPropType,
  item: fieldItemPropType,
  className: PropTypes.string,
  style: PropTypes.object
}

export default RSSFeedItemFooter
